import axios from 'axios';
import { getContext } from '@fiverr-private/fiverr_context';
import { logger } from '@fiverr-private/obs';
import pathfinder from '@fiverr-private/pathfinder';
import { GetSellerTemplatesDataResponse } from './types';

export const fetchSellerDocuments = async (sellerId?: number): Promise<GetSellerTemplatesDataResponse> => {
    const { userId, organizationId } = getContext();

    if (!userId || !organizationId) {
        const error = new Error(
            `Attempting to fetch documents for non authenticated user: ${userId} organization: ${organizationId}`
        );
        logger.error(error);
        throw new Error();
    }

    if (!sellerId) {
        const error = new Error(`Attempting to fetch documents for seller without sellerId`);
        logger.warn(error);
        throw new Error();
    }

    const { data } = await axios.get<GetSellerTemplatesDataResponse>(
        pathfinder('list_legal_documents', { seller_id: sellerId })
    );
    return data;
};

export const resendDocumentRequest = async (documentId: string) =>
    axios.post(pathfinder('resend_legal_document', { id: documentId }));

export const getSignedDocumentPreviewUrl = async (documentId: string): Promise<string> => {
    const { data } = await axios.get<string>(pathfinder('view_signed_legal_document', { id: documentId }));
    return data;
};

export const removeDocumentRequest = async (documentId: string) => {
    const path = pathfinder('delete_legal_document', { id: documentId });

    return axios.delete(path);
};
